
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/material-ui/guides/minimizing-bundle-size",
      function () {
        return require("private-next-pages/material-ui/guides/minimizing-bundle-size.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/material-ui/guides/minimizing-bundle-size"])
      });
    }
  